import { EDEditor } from '../lib/ed/editor';
import { EDFields } from '../lib/ed/fields';
import { EDI18NInput } from '../lib/ed/input';
import { EDSection } from '../lib/ed/section';
import { MContext, mTemplateFieldsForContext } from '../lib/mdl/m-template';
import { $el } from '../lib/ui/elements';
import { UIClassesSpec } from '../lib/ui/types';
import { YForm, $form } from '../lib/y/form';
import { YLanguage } from '../lib/y/i18n';

export class AdminSmsEditor extends EDEditor<any, any> {
    form: YForm;

    constructor(context: MContext, name: string, languages: YLanguage[], classes?: UIClassesSpec) {
        const [fields, _link_values] = mTemplateFieldsForContext(context);

        super(new EDFields(fields), [], [], name, languages, classes);

        const body = new EDI18NInput({ fields: this.fields, classes: 'r-body', placeholder: 'Body' })

        this.form = $form({ body });

        this.content.ui_prepend($el.DIV('tl-push-box', [
            body
        ]));

        this.content.addEventListener('click', e => {
            this.selectObject(this);
            e.stopPropagation();
        });
    }

    protected override makeSection(): EDSection<any, any> {
        return undefined as any;
    }

    protected override newSection(): never {
        throw 'Not implemented';
    }
}